const SSO_PROVIDER_ID = /^(oidc|saml)\.[A-Za-z0-9_-]+$/;
/** Whether a Firebase provider ID (or `sign_in_provider`) is an SSO one. */
export const isSsoProviderId = (providerId) => typeof providerId === 'string' && SSO_PROVIDER_ID.test(providerId);
/** `saml` or `oidc` for an SSO provider ID, otherwise null. */
export const getSsoProviderKind = (providerId) => isSsoProviderId(providerId)
    ? providerId.slice(0, providerId.indexOf('.'))
    : null;
